<template>
  <v-app>
    <v-app-bar flat app class="custom-app-bar">
      <div class="d-flex align-center">
        <v-img
          alt="flybysms Logo"
          class="shrink mr-2"
          contain
          src="@/assets/flybysms.svg"
          transition="scale-transition"
          width="120"
        />
      </div>
    </v-app-bar>
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6" md="4">
          <v-card width="500" class="pa-4 custom-card" flat>
            <!-- Your card content goes here -->
            <v-card-text align="center">
              <v-img
                alt="Success"
                class="shrink mr-2"
                contain
                src="success.svg"
                transition="scale-transition"
                width="120"
              />
            </v-card-text>
            <v-card-text class="text-center">
              <div
                class="text-h6 text-md-h5 text-lg-h4 text-color font-weight-bold font-theme black--text"
              >
                Check your email
              </div>
            </v-card-text>
            <v-card-text class="text-center">
              <div class="subtitle-1">
                Please go to your email inbox and click on the received link to
                reset your password.
              </div>
            </v-card-text>
            <v-card-text class="text-center">
              <div class="subtitle-1">
                Return to
                <span @click="routeToHandler" class="hover--text">Log in</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    routeToHandler() {
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 20px;
}
</style>
